module.exports = __webpack_public_path__ + "img/integration__view.6264307e.png";